import React from 'react';
//import { a } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    
        <div className='footer'>
            <a href="/"><i> Copyright &copy; 2022 Kinmat Tech. Online Stores. All Rights Reserved</i></a>
            </div>
  )
}

export default Footer